import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import moment from "moment-timezone";

moment.tz.setDefault("UTC");

Vue.filter( 'formatDate', function( value ) {
  if ( value ) {
    
    return moment( String( value ) ).format( 'MM/DD/YYYY' )
  }
} );

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#dvca-listings-root");
